import axios from "axios";

const AUTO_COMPLETE_SEARCH_URL = process.env.REACT_APP_API_AUTO_COMPLETE_SEARCH_ES_URL;
const AUTO_COMPLETE_UPDATE_URL = process.env.REACT_APP_API_AUTO_COMPLETE_UPDATE_ES_URL;

export const getAutoCompleteText = (keyword, searchItem = "company,patent,paper_title") => {
    const data = searchItem.split(",").reduce((acc, si) => {
        const newAcc = { ...acc };
        newAcc[si] = keyword;
        return newAcc;
    }, {});

    const res = axios.patch(`${AUTO_COMPLETE_SEARCH_URL}`, data, {
        params: {
            page: 1,
            size: 50,
        },
    });
    return res;
};

// 자동완성 리스트 정렬을 위한 검색된 단어 조회수 업데이트 함수
export const updateAutoCompleteTextViewCount = (searchKeyword) => {
    const formdata = new FormData();
    formdata.append("searchKeyword", searchKeyword);
    return axios.put(`${AUTO_COMPLETE_UPDATE_URL}`, formdata);
};
